<template>
  <v-col class="mt-0 pt-0">
    <ValidationObserver>
      <ValidationProvider v-slot="{ errors, validate }" :name="`'${label}'`" rules="email">
        <v-text-field
            v-model.trim="innerValue"
            :error-messages="errors.concat(errorMessages)"
            prepend-icon="alternate_email"
            :label="label"
            clearable
            append-icon="add"
            mb-0
            :readonly="readonly"
            @click:append="add(validate)"
            @click:clear="clear"
            @keydown.native.enter="add(validate)">
          <template v-if="required" v-slot:prepend-inner>
            <v-icon
                small
                left
                :color="requiredColor">
              *
            </v-icon>
          </template>
        </v-text-field>
      </ValidationProvider>
      <div
          v-if="items && items.length > 0"
          ma-0
          pa-0
          class="text-left">
        <v-chip
            v-for="(item, index) in items"
            :key="index"
            v-model="chips[index]"
            :close="!readonly"
            class="v-chip--select-multi"
            :title="item"
            @click:close="onClose(index)">
          {{ item }}
        </v-chip>
      </div>
    </ValidationObserver>
  </v-col>
</template>

<script>
  export default {
    props: {
      value: Array,
      label: String,
      readonly: {
        type: Boolean,
        default: false
      },
      errorMessages: Array,
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      required: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        innerValue: null,
        items: [],
        chips: []
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal, oldVal) {
          const vm = this
          // первичная инициализация, если в родительском компоненте заданы значения по умолчанию
          // либо изменение входных данных после загрузки с сервера
          if (newVal && newVal.length) {
            newVal.forEach(email => {
              if (!vm.items.includes(email)) {
                vm.items.push(email)
                vm.chips.push(true)
              }
            })
          }
        }
      }
    },
    methods: {
      add: async function (validate) {
        const result = await validate()
        if (result.valid && this.innerValue) {
          // для уникальности адресов
          if (!this.items.includes(this.innerValue)) {
            this.items.push(this.innerValue)
            this.chips.push(true)
            this.$emit('input', this.items)
          }
          this.innerValue = null
        }
      },
      clear: function () {
        if (this.innerValue) {
          this.innerValue = null
        } else {
          this.items = []
          this.chips = []
          this.$emit('input', [])
        }
      },
      onClose: function (index) {
        if (!this.readonly) {
          this.items.splice(index, 1)
          this.chips.splice(index, 1)
          this.$emit('input', this.items)
        }
      }
    }
  }
</script>
